import { HttpErrorResponse } from '@angular/common/http';
import {
    Component,
    EventEmitter,
    Injectable,
    Input,
    Output
} from '@angular/core';
import { Analytics } from './analytics.model';
import { UserClick } from './userclick.model';

@Component({
  selector: 'base-component',
  template: '',
  standalone: false
})
@Injectable()
export class BaseComponent {
  /**
   * Access token
   */
  @Input() accessToken!: string;

  /**
   * Emits event with analytic details such as, component load time and internal
   * state of component
   */
  @Output() analytics: EventEmitter<Analytics> = new EventEmitter();

  /**
   * Client ID
   */
  @Input() clientId!: string;

  /**
   * Contact ID
   */
  @Input() contactId!: string;

  /**
   * Emits event when a component provides data
   */
  @Output() data: EventEmitter<any> = new EventEmitter();

  /**
   * Environment
   */
  @Input() env!: string;

  /**
   * For third party
   */
  @Input() isThirdParty!: boolean;

  /**
   * Fired when a component has an error
   */
  @Output() onError = new EventEmitter<HttpErrorResponse>();

  /**
   * Fired when the API has successfully loaded its data in the component
   */
  @Output() onLoad = new EventEmitter<any>();

  /**
   * Enables or disables data caching
   */
  @Input() useCaching!: boolean;

  /**
   * Emits an event when a button on the component is clicked. (useful for logging business events)
   */
  @Output() userClick: EventEmitter<UserClick> = new EventEmitter(undefined);
}
